import React, { Component } from 'react';
import { connect } from 'react-redux';
import { addFlashMessage } from '../Store/actions/flashMessages';
import history from '../history';
import PropTypes from 'prop-types';
import { logout } from '../Store/actions/loginActions';

const requireOperationAuth = function (ComposedComponent) {
    class Authenticate extends Component {
        componentDidMount() {
            if (!this.props.isAuthenticated) {
                history.push('/login?t=' + new Date().getTime());
            }
        }

        componentDidUpdate(nextProps) {
            if (!nextProps.isAuthenticated) {
                history.push('/login?t=' + new Date().getTime());
            }
        }

        render() {
            return (
                <ComposedComponent {...this.props} />
            );
        }
    }

    Authenticate.propTypes = {
        isAuthenticated: PropTypes.bool.isRequired,
        user: PropTypes.object.isRequired,
        addFlashMessage: PropTypes.func.isRequired,
        logout: PropTypes.func.isRequired
    }

    function mapStateToProps(state) {
        return {
            isAuthenticated: state.auth.isAuthenticated,
            user: state.auth.user
        }
    }

    return connect(mapStateToProps, { addFlashMessage, logout })(Authenticate);
}

export default requireOperationAuth;
